<template>
    <b-modal id="modal-whatsapp" title="Add WhatsApp Content" hide-footer size="lg" centered @hidden="resetForm">
        <validation-observer ref="observer" v-slot="{ handleSubmit, invalid }">
            <b-form @submit.prevent="handleSubmit(validateAndSubmit)">
                <b-row>
                    <b-col md="6">
                        <b-form-group label="Post Name" label-for="campaign_name">
                            <validation-provider rules="required" #default="{ errors }" name="campaign name">
                                <b-form-input v-model="campaignName" :state="errors.length > 0 ? false : null"
                                    @blur="validateCampaignName" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                    </b-col>

                    <b-col md="6">
                        <b-form-group label="Post Template" label-for="email_template">
                            <validation-provider rules="required" #default="{ errors }" name="email template">
                                <b-form-select v-model="selectedTemplateId" :options="emailtemplatelist"
                                    @change="onTemplateSelect" :state="errors.length > 0 ? false : null" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                    </b-col>

                    <b-col md="6">
                        <b-form-group label="Budget" label-for="cost">
                            <validation-provider rules="required|numeric|min_value:1" #default="{ errors }" name="cost">
                                <b-form-input v-model="cost" placeholder="Enter Budget" type="number" 
                                    :state="errors.length > 0 ? false : null" @blur="validateCost" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                    </b-col>

                    <!-- Segment -->
                    <b-col md="6">
                        <b-form-group label="Segment" label-for="segment">
                            <validation-provider rules="required" #default="{ errors }" name="segment" vid="Segment">
                                <v-select v-model="selectedSegments" :options="segmentOptions" label="itemTitle"
                                    multiple :clearable="false" class="item-selector-title" placeholder="Select Item"
                                    :state="errors.length > 0 ? false : null" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                    </b-col>


                    <b-col md="12">
                        <b-form-group label="WhatsApp Content" label-for="whatsapp_content">
                            <validation-provider rules="required" #default="{ errors }" name="whatsapp content">
                                <b-form-textarea id="whatsapp_content" v-model="selectedTemplate.body"
                                    placeholder="WhatsApp content will be displayed here" readonly rows="7"
                                    :state="errors.length > 0 ? false : null" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                    </b-col>

                    <b-col v-if="templateInputs[selectedTemplateId]" md="12">
    <b-form-group label="Fill Details">
        <template v-for="(placeholder, key) in templateInputs[selectedTemplateId]">
            <validation-provider 
                :rules="getValidationRules(key)"
                #default="{ errors }" 
                :name="placeholder"
                :key="key"
            >
                <div class="mb-3">
                    <!-- Numeric Field (Discount) -->
                    <b-form-input 
                        v-if="isNumericField(key)" 
                        v-model="offerDetails[key]" 
                        :placeholder="placeholder" 
                        type="number" 
                        min="1" 
                        max="100" 
                        :state="errors.length > 0 ? false : null" 
                        @input="updateTemplateBody"  
                        @blur="validateOfferField(key)" 
                    />

                    <!-- Date Field -->
                    <b-form-datepicker 
                        v-else-if="isDateField(key)" 
                        v-model="offerDetails[key]" 
                        :placeholder="placeholder" 
                        :state="errors.length > 0 ? false : null"  
                        @input="updateTemplateBody"
                        @blur="validateOfferField(key)" 
                    />

                    <!-- Default Text Field -->
                    <b-form-input 
                        v-else 
                        v-model="offerDetails[key]" 
                        :placeholder="placeholder" 
                        :state="errors.length > 0 ? false : null" 
                        @input="updateTemplateBody"  
                        @blur="validateOfferField(key)" 
                    />

                    <!-- Improved Error Message -->
                    <div v-if="errors.length" class="text-danger d-flex align-items-center">
                        <b-icon icon="exclamation-triangle-fill"  />
                        <small>{{ errors[0] }}</small>
                    </div>
                </div>
            </validation-provider>
        </template>
    </b-form-group>
</b-col>

                    
                </b-row>

                <b-col md="12" class="d-flex justify-content-end">
                    <b-button type="submit" variant="primary">Save as draft</b-button>
                </b-col>
            </b-form>
        </validation-observer>
    </b-modal>

</template>

<script>
import { BModal, BForm, BFormGroup, BFormSelect, BFormInput, BFormDatepicker, BButton, BCol, BRow, BFormTextarea } from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapActions, mapGetters } from "vuex";
import VSelect from "vue-select";


export default {
    components: {
        BModal,
        BForm,
        BFormGroup,
        BFormSelect,
        BFormInput,
        BFormDatepicker,
        BButton,
        BCol,
        BRow,
        ValidationProvider,
        BFormTextarea,
        VSelect,
        ValidationObserver,
    },
    data() {
        return {
            campaignName: "",
            campaignId: this.$route.params.id,
            cost: "",
            selectedTemplateId: null,
            selectedSegments: [],
            segmentOptions: [],
            links: [""],
            emailtemplatelist: [
                "Limited Time Offer", "New Product Launch", "Seasonal Sale Announcement",
                "VIP Invitation", "Event Promotion", "Flash Sale Reminder","Hello World"
            ],
            selectedTemplate: { body: "" },
            offerDetails: {},
            emailTemplateList: [
    "Limited Time Offer", "New Product Launch", "Seasonal Sale Announcement",
    "VIP Invitation", "Event Promotion", "Flash Sale Reminder","Hello World"
],
selectedTemplate: { body: "" },
offerDetails: {},
templateFormats: {
    "Limited Time Offer": "Don't miss out on our exclusive offer! Get {{1}}% OFF on all items.\nShop now: {{2}}\nHurry, offer ends on {{3}}.",
    "New Product Launch": "We’re thrilled to announce our latest product: {{1}}!\nBe among the first to experience it. Learn more: {{2}}\nShop now and enjoy exclusive launch discounts!",
    "Seasonal Sale Announcement": "The {{1}} Sale is here! 🎉\nEnjoy up to {{2}}% OFF on selected items.\nShop the sale now: {{3}}\nHurry, sale ends on {{4}}!",
    "VIP Invitation": "Join our exclusive {{1}} Membership and enjoy special perks like discounts, early access to sales, and more!\nLearn more and join now: {{2}}\nYour VIP experience awaits! 💎",
    "Event Promotion": "Join us for {{1}}! 🎉\nParticipate and stand a chance to win exciting prizes.\nRegister now: {{2}}\nHurry, registration closes on {{3}}!",
    "Flash Sale Reminder": "Our FLASH SALE starts in {{1}} hours! ⏰\nEnjoy discounts up to {{2}}%.\nDon’t miss out! Shop here: {{3}}\nThis sale won’t last long!",
    "Hello World": "Welcome and congratulations!! This message demonstrates your ability to send a WhatsApp message notification from the Cloud API, hosted by Meta. Thank you for taking the time to test with us."

},
templateInputs: {
    "Limited Time Offer": { discount: "Enter Discount %", link: "Enter Store Link", expiryDate: "Enter Expiry Date" },
    "New Product Launch": { product: "Enter Product Name", link: "Enter Product Link" },
    "Seasonal Sale Announcement": {
        eventName: "Enter Sale/Event Name",
        discount: "Enter Discount %",
        link: "Enter Sale Link",
        expiryDate: "Enter Sale End Date"
    },
    "VIP Invitation": { membership: "Enter Membership Name", link: "Enter Membership Link" },
    "Event Promotion": { eventName: "Enter Event Name", link: "Enter Event Link", deadline: "Enter Registration Deadline" },
    "Flash Sale Reminder": { hours: "Enter Hours", discount: "Enter Discount %", link: "Enter Sale Link" }
},

            validationErrors: {
                campaignName: null,
                cost: null,
                selectedTemplateId: null,
            },
        };
    },

    computed: {
        ...mapGetters("marketingModule", {
            appid: "appid",
            campaignId: "campaignId",
            posts: "drafts",
            eventsTaskslist: "eventtasks",
            loadingMarketing: "loading",
        }),

        ...mapGetters("segmentModule", {
            segments: "segments",
            loading: "loading",
        }),
    },

    methods: {
        ...mapActions("marketingModule", [
            "getAppIdAction",
            "getPostAction",
            "removePostAction", "postSocialAction",
            "postMarketingCampaignAction",
            "getMarketingCampaignByIDAction",
            "putMarketingCampaignAction",
            "getCampaignDraftListAction", "postCampaignDraftAction",
            "getEventTaskListAction", "postEventTaskAction", "putEventTaskAction"
        ]),
        ...mapActions("segmentModule", ["getSegmentsAction"]),

        setFormData(item) {
            if (item) {
                this.campaignName = item.name || "";
                this.cost = item.budget || "";
                this.content = item.content || "";

                // Extract link from mediaDetails safely
                let mediaDetails = [];
                try {
                    mediaDetails = JSON.parse(item.mediaDetails || "[]");
                } catch (error) {
                    console.error("Error parsing media details:", error);
                }
                this.link = mediaDetails.length > 0 ? mediaDetails[0].Url.replace(/["]/g, '') : "";
                this.mediaType = mediaDetails.length > 0 ? mediaDetails[0].MediaType : "image";

                this.scheduleDate = item.scheduledPublishedDate
                    ? new Date(item.scheduledPublishedDate).toISOString().split("T")[0]
                    : null;
            }
        },

        stripHtmlTags(html) {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            return doc.body.textContent || "";
        },

        isDateField(key) {
        return key.toLowerCase().includes('date') || key.toLowerCase().includes('deadline');
    },

    isNumericField(key) {
        return key.toLowerCase().includes('discount') || key.toLowerCase().includes('price') || key.toLowerCase().includes('amount');
    },
    getValidationRules(key) {
        if (this.isNumericField(key)) {
            return { required: true, numeric: true, min_value: 1, max_value: 100 };
        } else if (this.isDateField(key)) {
            return { required: true };
        } else {
            return { required: true };
        }
    },

    validateOfferField(key) {
        if (!this.offerDetails[key] || this.offerDetails[key].trim() === "") {
            this.validationErrors[key] = `${this.templateInputs[this.selectedTemplateId][key]} is required`;
        } else {
            this.validationErrors[key] = null;
        }
    },
        resetModalData() {
            this.campaignName = "";
            this.cost = "";
            this.selectedTemplateId = null;
            this.links = [""];
            this.selectedTemplate = { body: "" };
            this.offerDetails = {};
        },
        submitCampaignForm() {
            if (!this.selectedTemplateId || !this.campaignName || !this.cost) {
                this.$swal("Error", "Please make sure to fill in details for content.", "error");
                return;
            }

            const templateInputs = this.templateInputs[this.selectedTemplateId] || {};

            const sortedKeys = Object.keys(templateInputs).sort();

            const parameters = sortedKeys.map((key) => {
                return {
                    type: "text", 
                    value: this.offerDetails[key] || "N/A"
                };
            });

            const object = {
                templateName: this.selectedTemplateId.replace(/\s+/g, '_').toLowerCase(), 
                parameters: parameters
            };
            const stringifiedObject = JSON.stringify(object);

            let loader = this.$swal({
                title: "Processing...",
                text: "Please wait while the draft is being added",
                onOpen: () => {
                    this.$swal.showLoading();
                },
                allowOutsideClick: () => !this.$swal.isLoading(),
                buttonsStyling: false,
                showConfirmButton: false,
            });

            const payload = {
                campaignId: this.campaignId,
                name: this.campaignName,
                status: "DRAFT",
                budget: this.cost,
                content: JSON.stringify(this.selectedTemplate),
                platform: "WhatsApp",
                templateMetadata: stringifiedObject,
                segmentId: this.selectedSegments.map(segment => segment.value),
                mediaDetails: [
                    {
                        Path: "",
                        Url: "",
                        MediaType: ""
                    },
                ],

            };
            console.log("payload whatsapp:", payload);
            console.log("payload content:", this.selectedTemplate);
            this.postCampaignDraftAction(payload)
                .then((response) => {
                    loader.close();
                    if (response.success) {
                        this.$swal({
                            title: "Success",
                            text: "Draft added successfully!",
                            icon: "success",
                            confirmButtonText: "OK"
                        });

                        this.$emit("content-updated");
                        this.$bvModal.hide("modal-instagram");
                    } else {
                        throw new Error("Failed to add draft.");
                    }
                    // Reset the form
                    this.newCost = {
                        campaignId: this.campaignId,
                        category: "",
                        description: "",
                        amount: null,
                        date: "",
                    };

                    this.$bvModal.hide("modal-whatsapp");

                })
                .catch((error) => {
                    console.error("Error adding cost:", error);
                    loader.close();
                    this.$swal({
                        title: "Error",
                        text: "Failed to add draft. Please try again.",
                        icon: "error",
                        confirmButtonText: "OK"
                    });
                });
        },
        onTemplateSelect() {
            if (this.selectedTemplateId && this.templateFormats[this.selectedTemplateId]) {
                this.selectedTemplate = { body: this.templateFormats[this.selectedTemplateId] };
            } else {
                this.selectedTemplate = { body: "Select a template to see content here..." };
            }
            this.offerDetails = {}; 
        },
        updateTemplateBody() {
            if (!this.selectedTemplateId || !this.templateFormats[this.selectedTemplateId]) {
                this.selectedTemplate.body = "Select a template to see content here...";
                return;
            }

            let template = this.templateFormats[this.selectedTemplateId];

            Object.keys(this.templateInputs[this.selectedTemplateId] || {}).forEach((key, index) => {
                const value = this.offerDetails[key] || `{{${index + 1}}}`;
                template = template.replace(new RegExp(`\\{\\{${index + 1}\\}\\}`, 'g'), value);
            });

            this.selectedTemplate.body = template;
        }
        ,
        validateCampaignName() {
            this.validationErrors.campaignName = this.campaignName.trim() !== "" ? null : "Post Name is required";
        },
        validateCost() {
            this.validationErrors.cost = this.cost > 0 ? null : "Cost must be greater than zero";
        },
        validateTemplate() {
            this.validationErrors.selectedTemplateId = this.selectedTemplateId ? null : "Template selection is required";
        },
        validateOfferDetails() {
            const templateFields = this.templateInputs[this.selectedTemplateId] || {};
            let isValid = true;

            Object.keys(templateFields).forEach((key) => {
                if (!this.offerDetails[key] || this.offerDetails[key].trim() === "") {
                    this.validationErrors[key] = `${templateFields[key]} is required`;
                    isValid = false;
                } else {
                    this.validationErrors[key] = null;
                }
            });

            return isValid;
        },
        validateOfferField(key) {
            if (!this.offerDetails[key] || this.offerDetails[key].trim() === "") {
                this.validationErrors[key] = `${this.templateInputs[this.selectedTemplateId][key]} is required`;
            } else {
                this.validationErrors[key] = null;
            }
        },
        validateAndSubmit() {
            this.validateCampaignName();
            this.validateCost();
            this.validateTemplate();
            const isOfferDetailsValid = this.validateOfferDetails();

            const hasErrors = Object.values(this.validationErrors).some(error => error !== null);
            if (!hasErrors && isOfferDetailsValid) {
                this.submitCampaignForm();
            } else {
                this.$swal({
                    title: "Validation Error",
                    text: "Please fill in all required fields.",
                    icon: "error",
                    confirmButtonText: "OK",
                    customClass: {
                        confirmButton: "btn btn-danger",
                    },
                });
            }
        },
        resetForm() {
            this.campaignName = "";
            this.cost = "";
            this.selectedTemplateId = null;
            this.offerDetails = {};
            this.selectedTemplate = { body: "" };
            this.selectedSegments = [];
            this.validationErrors = {};
        },
    },
    async mounted() {
        this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
            if (modalId === 'modal-whatsapp') {
                this.resetModalData();
            }
        });

        await this.getSegmentsAction().then(() => {
            this.segmentOptions = this.segments.map((segment) => ({
                value: segment.segmentId,
                itemTitle: `${segment.name}`,
            }));
        });
    }
};
</script>


<style>
.item-selector-title {
    width: 100%;
}
</style>
